import address from './address';
import auth from './auth';
import accounting from './accounting';
import analytics from './analytics';
import errors from './errors';
import date from './date';
import anketa from './anketa';
import decisions from './decisions';
import report from './report';
import guarantors from './guarantors';
import requisites from './requisites';
import courts from './courts';
import chat from './chat';
import form from './form';

const common = {
  legalEntity: 'Юр. лицо',
  individual: 'Физ. лицо',
  name: 'Имя',
  phone: 'Телефон',
  role: 'Роль',
  limit: 'Лимит',
  count: 'Количество',
  term: 'Срок',
  delay: 'Отсрочка',
  dateTo: 'Срок действия',
  comment: 'Комментарий',
  status: 'Статус',
  postponement: 'Отсрочка',
  description: 'Описание',
  id: 'ИД',
  heads: 'Учредители и участники',
  loanCategories: 'Категории кредитов',
  object: 'Объект',
  objects: 'Объекты',
  relatedPersonsAndOrganizations: 'Связанные лица и организации',
  assuranceAndGuarantor: 'Обеспечение и поручители',
  listOfObjects: 'Список объектов',
  client: 'Клиент',
  clients: 'Клиенты',
  debitors: 'Дебиторы',
  code: 'Код',
  type: 'Тип',
  generalContractor: 'Генподрядчик',
  businessUnit: 'БЕ',
  contract: 'Договор',
  scoringScore: 'Скоринговый балл',
  score: 'Балл',
  more: 'Подробнее',
  stopFactors: 'Стоп-факторы',
  riskFactors: 'Риск-факторы',
  businessActivity: 'Деловая активность',
  value: 'Значение',
  marker: 'Маркер',
  markerList: 'Список маркеров',
  legalSigns: 'Юридические признаки',
  owner: 'Собственник',
  typeOfEntity: 'Тип лица',
  salesOfCost: 'Себестоимость продаж',
  profitOrLossFromSales: 'Прибыль (убыток) от продаж',
  profitOrLossBeforeTax: 'Прибыль (убыток) до налогообложения',
  percentageToBePaid: 'Проценты к уплате',
  otherIncome: 'Прочие доходы',
  otherOutcome: 'Прочие расходы',
  netProfit: 'Чистая прибыль (убыток)',
  main: 'Главная',
  otherCategories: 'Другие категории',
  openSideMenu: 'Открыть боковое меню',
  requestedConditions: 'Запрашиваемые условия',
  result: 'Результат',
  chart: 'График',
  table: 'Таблица',
  noFiles: 'По данной анкете нет файлов',
  search: 'Поиск',
  filters: 'Фильтры',
  clear: 'Очистить',
  actualDateOfScore: 'Дата актуальности балла',
  updateScore: 'Обновить балл',
  updatingScore: 'Обновление балла',
  ...address,
  ...errors,
  ...date,
  ...auth,
  ...anketa,
  ...decisions,
  ...report,
  ...guarantors,
  ...analytics,
  ...courts,
  ...chat,
  ...requisites,
  ...accounting,
  ...form,
};

export default common;
